import { shippingMethodVisibility } from '@/configuration/pages/ConfigurationPage/LogisticsConfiguration/ShippingMethods/constants'

export const visibilityOptions = [
  { value: shippingMethodVisibility.public, label: 'Público' },
  { value: shippingMethodVisibility.internal, label: 'Uso interno' },
]
